<template>
    <md-list>
        <md-subheader>{{ header || '' }}</md-subheader>
        <md-list-item v-for="(label, key, i)  in labels || {}" :key="i">
            <slot name="row" :label="key" :attribute="label" :getByAttribute="getByAttribute" >
                <div class="md-list-item-text">
                    <span><small class="text-muted">{{key}}</small></span>
                    <span>{{getByAttribute(label)}}</span> 
                </div>    
            </slot>    
        </md-list-item>
    </md-list>
</template>
<script>
export default {
    props:[
        "header",
        "info",
        "labels"
    ],
    data () {
        return {
            data: {}
        }
    },
    methods:{
        getByAttribute(attr, returnObjs = false ){
            if (this.data instanceof Object && attr && attr.constructor && attr.constructor.name === "String") {
                const value = this.data[attr]
                if (returnObjs && value instanceof Object){
                    return value
                }
                try {
                    
                    return value && value != 0 && value.constructor && value.constructor.name && ( value.constructor.name === 'Number' || value.constructor.name === 'String' ) 
                    ? value 
                    : 'Sin información' 
                } catch (error) {}
            }
            return 'Sin información'
        }
    },
    watch: {
        info( val ) {
            if (val instanceof Object) {
                this.data = val
            }
        }
    }
    
}
</script>

<style lang="scss"  scoped >
.separated {
    margin: 0.7em;   
    background-color: #eceef7da !important;
}
.md-list {
     padding: 0.7rem;
}

.md-divider {
    height: 1px;
    color: #4b647a98 !important;
}

.md-card .md-card-header .vs-avatar-content{
    height: 100% !important; 
}

.md-card-header-text {
    margin-left: 1em;
}

.md-list-item-text {
  white-space: normal !important;
  padding-bottom: 0.5rem;
}

</style>